export const resolvePlayerImageUrl = (item) => {
  if (!item?.image) return null
  return item.is_avatar === 1
    ? `${process.env.REACT_APP_PLAYER_AVATAR_URL}${item.image}`
    : `${process.env.REACT_APP_API_URL}uploads/player/${item.image}`
}

export const resolveTeamSponsorUrl = (imagePath) =>
  imagePath ? `${process.env.REACT_APP_API_URL}uploads/team_sponsor/${imagePath}` : null
